// extracted by mini-css-extract-plugin
module.exports = {"ImageIconContainer":"style_ImageIconContainer__2XxeG","ImageIcon":"style_ImageIcon__1nArV"};